(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  const root = document.querySelector('[data-popup]');
  if (!root) return;
  const configEl = root.querySelector('[data-popup-config]');
  let CONFIG;
  try { CONFIG = JSON.parse(configEl.textContent); } catch (e) { return; }
  if (!CONFIG.variants || !CONFIG.variants.length) return;

  /* ---------- storage (namespaced to lala — never shares with other stores) ---------- */
  const LS_KEY = 'lala_popup_v1';
  function loadState() {
    try { return JSON.parse(localStorage.getItem(LS_KEY) || '{}'); } catch (_) { return {}; }
  }
  function saveState(patch) {
    Object.assign(state, patch);
    try { localStorage.setItem(LS_KEY, JSON.stringify(state)); } catch (_) {}
    return state;
  }
  const state = loadState();

  function sessionId() {
    let s = sessionStorage.getItem('lala_popup_session');
    if (!s) {
      s = 'p_' + (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36));
      sessionStorage.setItem('lala_popup_session', s);
    }
    return s;
  }

  /* ---------- variant assignment (50/50 across enabled blocks) ---------- */
  function assignVariant() {
    if (state.variant) {
      const found = CONFIG.variants.find(v => v.key === state.variant);
      if (found) return found;
    }
    const idx = CONFIG.variants.length === 1 ? 0 : (Math.random() < 0.5 ? 0 : 1);
    const v = CONFIG.variants[idx];
    saveState({ variant: v.key });
    return v;
  }

  /* ---------- env ---------- */
  const isMobile  = window.matchMedia('(max-width: 699px)').matches;
  const isPDP     = location.pathname.indexOf('/products/') !== -1;
  const utmParams = new URLSearchParams(location.search);
  const utmSource = utmParams.get('utm_source') || null;

  /* ---------- kill switches ---------- */
  if (state.state === 'submitted') {
    const elapsedDays = (Date.now() - (state.submittedAt || 0)) / 86400000;
    const submittedVariant = CONFIG.variants.find(v => v.key === state.variant) || CONFIG.variants[0];
    if (elapsedDays < submittedVariant.suppress.submitDays) return;
  }
  if (utmSource === 'klaviyo') { saveState({ state: 'suppressed', suppressedAt: Date.now() }); return; }
  if (state.state === 'suppressed') return;
  if (location.pathname.indexOf('/cart') !== -1 || location.pathname.indexOf('/checkout') !== -1) return;

  const variant = assignVariant();

  /* ---------- copy resolver ---------- */
  function resolveCopy() {
    const c = variant.copy;
    const returning = state.popupSeen === 1 && state.state !== 'submitted';
    return {
      kicker:       c.kicker,
      title:        returning && c.titleReturning ? c.titleReturning : c.titleNew,
      body:         returning && c.bodyReturning  ? c.bodyReturning  : c.bodyNew,
      claimLabel:   c.claimLabel,
      submitLabel:  c.submitLabel,
      privacyLine:  c.privacyLine,
      tyTitle:      c.tyTitle,
      tyBody:       c.tyBody,
      tyCloseLabel: c.tyCloseLabel,
      widgetLabel:  isMobile && c.widgetLabelMobile ? c.widgetLabelMobile : c.widgetLabel
    };
  }

  /* ---------- tracking (anonymous, site-scoped) ---------- */
  function track(type, extra) {
    if (!CONFIG.trackUrl) return;
    const body = Object.assign({
      type, site: CONFIG.site, session: sessionId(),
      page: location.pathname,
      device: isMobile ? 'mobile' : 'desktop',
      variant: variant.key,
      language: CONFIG.language || null,
      utm_source: utmSource,
      utm_medium:   utmParams.get('utm_medium')   || null,
      utm_campaign: utmParams.get('utm_campaign') || null,
      utm_content:  utmParams.get('utm_content')  || null,
      utm_term:     utmParams.get('utm_term')     || null,
      referrer: document.referrer || null
    }, extra || {});
    try {
      fetch(CONFIG.trackUrl, {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).catch(() => {});
    } catch (_) {}
  }

  /* ---------- DOM refs ---------- */
  const card        = root.querySelector('[data-popup-card]');
  const backdrop    = root.querySelector('[data-popup-backdrop]');
  const kickerEl    = root.querySelector('[data-popup-kicker]');
  const titleEl     = root.querySelector('[data-popup-title]');
  const bodyEl      = root.querySelector('[data-popup-body]');
  const submitBtn   = root.querySelector('[data-popup-submit]');
  const privacyEl   = root.querySelector('[data-popup-privacy]');
  const closeBtn    = root.querySelector('[data-popup-close]');
  const form        = root.querySelector('[data-popup-form]');
  const emailIn     = root.querySelector('[data-popup-email]');
  const errEl       = root.querySelector('[data-popup-error]');
  const viewForm    = root.querySelector('[data-popup-view="form"]');
  const viewThanks  = root.querySelector('[data-popup-view="thanks"]');
  const tyTitleEl   = root.querySelector('[data-popup-ty-title]');
  const tyBodyEl    = root.querySelector('[data-popup-ty-body]');
  const tyCloseBtn  = root.querySelector('[data-popup-ty-close]');
  const widget      = root.querySelector('[data-popup-widget]');
  const widgetLabel = root.querySelector('[data-popup-widget-label]');
  const prizeEl       = root.querySelector('[data-popup-prize]');
  const prizeTagEl    = root.querySelector('[data-popup-prize-tag]');
  const prizeAmountEl = root.querySelector('[data-popup-prize-amount]');
  const prizeSubEl    = root.querySelector('[data-popup-prize-subtitle]');
  const claimBtn      = root.querySelector('[data-popup-claim]');
  const scratchCv     = root.querySelector('[data-popup-scratch-canvas]');

  function applyCopy() {
    const c = resolveCopy();
    if (kickerEl)   kickerEl.textContent    = c.kicker || '';
    if (titleEl)    titleEl.innerHTML       = c.title || '';
    if (bodyEl)     bodyEl.innerHTML        = c.body || '';
    if (submitBtn)  submitBtn.textContent   = c.submitLabel || 'Atsiimti nuolaidą';
    if (privacyEl)  privacyEl.textContent   = c.privacyLine || '';
    if (tyTitleEl)  tyTitleEl.innerHTML     = c.tyTitle || '';
    if (tyBodyEl)   tyBodyEl.innerHTML      = c.tyBody || '';
    if (tyCloseBtn) tyCloseBtn.textContent  = c.tyCloseLabel || '';
    if (widgetLabel) widgetLabel.textContent = c.widgetLabel || '';
    if (prizeTagEl)    prizeTagEl.textContent    = CONFIG.prizeTag || '';
    if (prizeAmountEl) prizeAmountEl.textContent = CONFIG.prizeAmount || '';
    if (prizeSubEl)    prizeSubEl.textContent    = CONFIG.prizeSubtitle || '';
    if (claimBtn)      claimBtn.textContent      = c.claimLabel || c.submitLabel || 'Atsiimti';
  }
  applyCopy();

  /* ---------- scratch card ---------- */
  let scratchInited = false;
  function initScratch() {
    if (scratchInited) return;
    scratchInited = true;
    const useScratch = variant.scratch && variant.scratch.enabled && scratchCv;
    if (!useScratch) {
      if (scratchCv && scratchCv.parentNode) scratchCv.parentNode.removeChild(scratchCv);
      setFormStep('revealed');
      return;
    }
    const dpr = window.devicePixelRatio || 1;
    const rect = prizeEl.getBoundingClientRect();
    scratchCv.width  = Math.max(1, Math.round(rect.width  * dpr));
    scratchCv.height = Math.max(1, Math.round(rect.height * dpr));
    const ctx = scratchCv.getContext('2d', { willReadFrequently: true });
    ctx.scale(dpr, dpr);

    const label = (variant.scratch.label || 'NUBRAUK ČIA').toUpperCase();

    function paintLabel() {
      const fs = Math.max(13, Math.round(rect.width / 16));
      ctx.save();
      ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = 'rgba(28, 24, 18, 0.55)';
      ctx.font = '600 ' + fs + 'px "JetBrains Mono", ui-monospace, monospace';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.shadowColor = 'rgba(255, 255, 255, 0.6)';
      ctx.shadowBlur = 6;
      ctx.fillText(label, rect.width / 2, rect.height / 2);
      ctx.restore();
    }
    /* Watercolour-wash foil in the lala palette (blush → mist → sage). */
    function paintGradient() {
      const grad = ctx.createLinearGradient(0, 0, rect.width, rect.height);
      grad.addColorStop(0,   '#F3D9D4');
      grad.addColorStop(0.5, '#C8D4DB');
      grad.addColorStop(1,   '#B5C2AE');
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, rect.width, rect.height);
    }
    function paintImageCover(img) {
      const ar = img.naturalWidth / img.naturalHeight;
      const cAR = rect.width / rect.height;
      let sx, sy, sw, sh;
      if (ar > cAR) { sh = img.naturalHeight; sw = sh * cAR; sx = (img.naturalWidth - sw) / 2; sy = 0; }
      else { sw = img.naturalWidth; sh = sw / cAR; sx = 0; sy = (img.naturalHeight - sh) / 2; }
      ctx.drawImage(img, sx, sy, sw, sh, 0, 0, rect.width, rect.height);
    }

    paintGradient();
    paintLabel();

    let scratchStarted = false;
    const imgUrl = CONFIG.scratchImageUrl;
    if (imgUrl) {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        if (scratchStarted) return;
        ctx.save(); ctx.globalCompositeOperation = 'source-over';
        ctx.clearRect(0, 0, rect.width, rect.height); ctx.restore();
        paintImageCover(img); paintLabel();
      };
      img.src = imgUrl;
    }

    let lastX = null, lastY = null, active = false, revealed = false, progressCheckPending = false;
    function rectAt() { return scratchCv.getBoundingClientRect(); }
    function ptFromEvent(e) {
      const r = rectAt();
      const t = e.touches ? e.touches[0] : e;
      return { x: t.clientX - r.left, y: t.clientY - r.top };
    }
    function erase(x, y) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.fillStyle = '#000';
      if (lastX != null) {
        ctx.strokeStyle = '#000'; ctx.lineWidth = 22; ctx.lineCap = 'round';
        ctx.beginPath(); ctx.moveTo(lastX, lastY); ctx.lineTo(x, y); ctx.stroke();
      }
      ctx.beginPath(); ctx.arc(x, y, 11, 0, Math.PI * 2); ctx.fill();
      lastX = x; lastY = y;
      scheduleProgressCheck();
    }
    function scheduleProgressCheck() {
      if (progressCheckPending || revealed) return;
      progressCheckPending = true;
      setTimeout(checkProgress, 120);
    }
    function checkProgress() {
      progressCheckPending = false;
      if (revealed) return;
      let data;
      try { data = ctx.getImageData(0, 0, scratchCv.width, scratchCv.height).data; }
      catch (e) { return; }
      let cleared = 0, total = 0;
      const stride = 4 * 80;
      for (let i = 3; i < data.length; i += stride) { total++; if (data[i] < 40) cleared++; }
      if (total > 0 && cleared / total >= 0.65) revealScratch();
    }
    function revealScratch() {
      if (revealed) return;
      revealed = true;
      scratchCv.classList.add('is-revealed');
      track('scratch_revealed');
      saveState({ scratched: 1 });
      setFormStep('revealed');
      setTimeout(() => {
        if (scratchCv && scratchCv.parentNode) scratchCv.parentNode.removeChild(scratchCv);
        if (claimBtn) {
          claimBtn.setAttribute('data-noring', '1');
          var clearNoRing = function () {
            claimBtn.removeAttribute('data-noring');
            claimBtn.removeEventListener('keydown', clearNoRing);
            claimBtn.removeEventListener('blur', clearNoRing);
          };
          claimBtn.addEventListener('keydown', clearNoRing);
          claimBtn.addEventListener('blur', clearNoRing);
          try { claimBtn.focus({ preventScroll: true }); } catch (_) {}
        }
      }, 620);
    }
    function down(e) { e.preventDefault(); active = true; scratchStarted = true; lastX = null; const p = ptFromEvent(e); erase(p.x, p.y); }
    function move(e) { if (!active) return; e.preventDefault(); const p = ptFromEvent(e); erase(p.x, p.y); }
    function up() { active = false; lastX = null; lastY = null; }
    scratchCv.addEventListener('mousedown', down);
    scratchCv.addEventListener('mousemove', move);
    document.addEventListener('mouseup', up);
    scratchCv.addEventListener('touchstart', down, { passive: false });
    scratchCv.addEventListener('touchmove',  move, { passive: false });
    scratchCv.addEventListener('touchend',   up);
  }

  /* ---------- state machine ---------- */
  let machineState = 'dormant';
  let dismissedAt  = 0;
  let interval;

  function setState(s) {
    machineState = s;
    root.setAttribute('data-popup-state', s);
    if (card) card.setAttribute('aria-hidden', s === 'shown' || s === 'thanks' ? 'false' : 'true');
  }
  function setFormStep(step) { if (viewForm) viewForm.setAttribute('data-form-step', step); }

  function showFull() {
    viewForm.classList.add('lapop__view--snap');
    applyCopy();
    viewForm.hidden = false;
    viewThanks.hidden = true;
    const alreadyScratched = state.scratched === 1;
    const useScratch = variant.scratch && variant.scratch.enabled && !alreadyScratched;
    setFormStep(useScratch ? 'scratch' : 'revealed');
    setState('shown');
    widget.setAttribute('data-visible', '0');
    track('shown');
    if (useScratch) { requestAnimationFrame(() => requestAnimationFrame(initScratch)); }
    else if (scratchCv && scratchCv.parentNode) { scratchCv.parentNode.removeChild(scratchCv); }
    requestAnimationFrame(() => requestAnimationFrame(() => viewForm.classList.remove('lapop__view--snap')));
  }
  function showWidget(bounce) {
    widget.removeAttribute('hidden');
    widget.setAttribute('data-visible', '1');
    if (bounce) { widget.setAttribute('data-bounce', '1'); setTimeout(() => widget.removeAttribute('data-bounce'), 800); }
  }
  function minimize() { setState('minimized'); showWidget(false); }
  function suppressForever() {
    saveState({ state: 'suppressed', suppressedAt: Date.now() });
    setState('suppressed');
    widget.setAttribute('data-visible', '0');
  }
  function showThanks() { viewForm.hidden = true; viewThanks.hidden = false; setState('thanks'); }

  function dismiss(method) {
    if (machineState === 'thanks' || state.state === 'submitted') { suppressForever(); return; }
    track('dismissed', { method });
    saveState({ state: 'dismissed', dismissedAt: Date.now(), popupSeen: 1 });
    dismissedAt = Date.now();
    minimize();
    startMinimizedBehavior();
  }

  /* ---------- Klaviyo ---------- */
  function identifyKlaviyo(email) {
    try {
      window.klaviyo = window.klaviyo || [];
      // `language` lands on the PROFILE so welcome flows / campaigns can branch
      // per storefront locale (lt, en, pl, lv, sv, es, fr, it).
      window.klaviyo.push(['identify', {
        $email: email,
        $source: 'site_popup',
        popup_variant: variant.key,
        language: CONFIG.language || '',
        language_name: CONFIG.languageName || '',
        country: CONFIG.country || ''
      }]);
      window.klaviyo.push(['track', 'Popup Submitted', {
        variant: variant.key,
        source: 'site_popup',
        page: location.pathname,
        language: CONFIG.language || '',
        country: CONFIG.country || ''
      }]);
    } catch (_) {}
  }

  async function submitEmail(email) {
    const listId = variant.klaviyoListId || '';
    if (!CONFIG.klaviyoCompanyId || !listId) {
      identifyKlaviyo(email);
      track('submitted');
      saveState({ state: 'submitted', submittedAt: Date.now(), popupSeen: 1, email: email });
      showThanks();
      return;
    }
    // Custom profile properties travel with the subscription, so the contact is
    // created in Klaviyo already tagged with its language — no second API call.
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  language: CONFIG.language || '',
                  language_name: CONFIG.languageName || '',
                  country: CONFIG.country || '',
                  popup_variant: variant.key,
                  signup_source: 'site_popup'
                }
              }
            }
          },
          custom_source: 'site_popup'
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };
    const res = await fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(CONFIG.klaviyoCompanyId),
      { method: 'POST', headers: { 'Content-Type': 'application/json', 'Revision': '2024-10-15' }, body: JSON.stringify(payload) }
    );
    if (!res.ok && res.status !== 202) throw new Error('Klaviyo subscribe failed: ' + res.status);
    identifyKlaviyo(email);
    track('submitted');
    saveState({ state: 'submitted', submittedAt: Date.now(), popupSeen: 1, email: email });
    showThanks();
  }

  // Re-identify on every page load so on-site events stay attributed, and keep
  // `language` fresh — if they switch to /pl later, the profile follows.
  if (state.email) {
    try {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['identify', {
        $email: state.email,
        popup_variant: state.variant || variant.key,
        language: CONFIG.language || '',
        language_name: CONFIG.languageName || '',
        country: CONFIG.country || ''
      }]);
    } catch (_) {}
  }

  /* ---------- wiring ---------- */
  closeBtn.addEventListener('click', () => dismiss('x'));
  backdrop.addEventListener('click', () => { if (machineState === 'shown') dismiss('backdrop'); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && machineState === 'shown') dismiss('esc'); });

  if (claimBtn) {
    claimBtn.addEventListener('click', () => {
      setFormStep('email');
      setTimeout(() => { try { emailIn.focus({ preventScroll: true }); } catch (_) {} }, 360);
    });
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (viewForm.getAttribute('data-form-step') !== 'email') return;
    const email = (emailIn.value || '').trim();
    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      errEl.textContent = 'Įvesk teisingą el. paštą.';
      errEl.hidden = false;
      return;
    }
    errEl.hidden = true;
    submitBtn.disabled = true;
    try { await submitEmail(email); }
    catch (err) {
      errEl.textContent = 'Nepavyko užsiprenumeruoti. Bandyk dar kartą.';
      errEl.hidden = false;
      submitBtn.disabled = false;
    }
  });

  tyCloseBtn.addEventListener('click', suppressForever);
  widget.addEventListener('click', showFull);

  /* ---------- consent gate ---------- */
  function waitForConsent(cb) {
    const SELECTORS = '#shopify-pc__banner, [data-tracking-consent], .shopify-pc__banner__dialog, [class*="tracking-consent"], [class*="cookie-banner"], [class*="consent-banner"]';
    const start = Date.now();
    let stableTicks = 0;
    const probe = () => {
      const banner = document.querySelector(SELECTORS);
      const visible = banner && banner.offsetParent !== null;
      if (!visible) { stableTicks++; if (stableTicks >= 2) return cb(); }
      else { stableTicks = 0; }
      if (Date.now() - start > 10000) return cb();
      setTimeout(probe, 250);
    };
    probe();
  }

  /* ---------- triggers ---------- */
  function eligibilityDelayS() {
    if (state.state === 'dismissed' && isPDP) return variant.trigger.pdpRefireS;
    return null;
  }
  function startTriggers() {
    let scrolledEnough = false, scrolledPct = 0;
    function maxScrollPct() {
      const doc = document.documentElement;
      const max = doc.scrollHeight - doc.clientHeight;
      if (max <= 0) return 100;
      return Math.min(100, (window.scrollY / max) * 100);
    }
    function onScroll() {
      scrolledPct = Math.max(scrolledPct, maxScrollPct());
      if (scrolledPct >= variant.trigger.scrollPct) scrolledEnough = true;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    const armedAt = Date.now();
    setTimeout(function fire() {
      if (machineState !== 'dormant') return;
      const refireS = eligibilityDelayS();
      const minWaitMs = refireS != null ? refireS * 1000 : 0;
      if (Date.now() - armedAt < minWaitMs) { setTimeout(fire, 500); return; }
      if (scrolledEnough) showFull();
      else setTimeout(fire, 500);
    }, variant.trigger.cookieWaitMs);
  }

  function startMinimizedBehavior() {
    if (interval) clearInterval(interval);
    let lastMove = Date.now(), idleBounced = false;
    let dirChanges = 0, lastScrollY = window.scrollY, lastScrollDir = 0;

    if (!isMobile) {
      function onMouseMove(e) {
        lastMove = Date.now();
        idleBounced = false;
        if (machineState !== 'minimized') return;
        if (e.clientY <= 0) {
          const engagedS = (Date.now() - dismissedAt) / 1000;
          if (engagedS >= variant.trigger.exitIntentEngagedS) {
            window.removeEventListener('mousemove', onMouseMove);
            showFull();
          }
        }
      }
      window.addEventListener('mousemove', onMouseMove);
      interval = setInterval(() => {
        if (machineState !== 'minimized') return;
        if (document.visibilityState !== 'visible') return;
        if (idleBounced) return;
        if (variant.trigger.idleNudgeS <= 0) return;
        if ((Date.now() - lastMove) / 1000 >= variant.trigger.idleNudgeS) { showWidget(true); idleBounced = true; }
      }, 1000);
    } else {
      if (isPDP) return;
      if (variant.trigger.mobileEngagedS <= 0) return;
      function onScrollM() {
        if (machineState !== 'minimized') return;
        const y = window.scrollY;
        const dir = y > lastScrollY ? 1 : (y < lastScrollY ? -1 : 0);
        if (dir !== 0 && dir !== lastScrollDir) { dirChanges++; lastScrollDir = dir; }
        lastScrollY = y;
        const engagedS = (Date.now() - dismissedAt) / 1000;
        if (dirChanges >= variant.trigger.mobileScrollDirs && engagedS >= variant.trigger.mobileEngagedS) {
          window.removeEventListener('scroll', onScrollM);
          showFull();
        }
      }
      window.addEventListener('scroll', onScrollM, { passive: true });
    }
  }

  /* ---------- boot ---------- */
  waitForConsent(() => {
    if (state.state === 'dismissed') {
      const elapsedDays = (Date.now() - (state.dismissedAt || 0)) / 86400000;
      if (elapsedDays < variant.suppress.dismissDays) {
        dismissedAt = state.dismissedAt || Date.now();
        minimize();
        startMinimizedBehavior();
        return;
      }
    }
    startTriggers();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
